/* Novele: bundle selector, shipping protection, sticky ATC */
(function () {
  'use strict';

  /* ---------- Bundle quantity tiers ---------- */
  class NoveleBundle extends HTMLElement {
    connectedCallback() {
      this.qty = this.querySelector('.nov-bundle__qty');
      this.tiers = this.querySelectorAll('.nov-tier');
      this.tiers.forEach((tier) => {
        tier.addEventListener('click', () => this.select(tier));
      });
    }
    select(tier) {
      this.tiers.forEach((t) => t.classList.toggle('is-active', t === tier));
      const radio = tier.querySelector('input[type=radio]');
      if (radio) radio.checked = true;
      this.qty.value = tier.dataset.qty;
      // keep any visible quantity input in sync
      const form = document.getElementById(this.dataset.form);
      if (form) {
        const visible = document.querySelector(`quantity-input input[form="${this.dataset.form}"]`);
        if (visible) visible.value = tier.dataset.qty;
      }
    }
  }
  if (!customElements.get('novele-bundle')) customElements.define('novele-bundle', NoveleBundle);

  /* ---------- Shipping protection ---------- */
  const PROTECTION = {
    get variantId() {
      const el = document.querySelector('[data-novele-protection]');
      return el ? Number(el.dataset.variantId) : null;
    },
    async cart() {
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      return r.json();
    },
    sections() {
      return 'cart-drawer,cart-icon-bubble';
    },
    async add(id) {
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: this.sections() }),
      });
      return r.json();
    },
    async setQty(id, quantity) {
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(id), quantity, sections: this.sections() }),
      });
      return r.json();
    },
    render(state) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && state && state.sections) {
        drawer.getSectionsToRender().forEach((section) => {
          const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (!el || !state.sections[section.id]) return;
          const html = new DOMParser().parseFromString(state.sections[section.id], 'text/html');
          const src = html.querySelector(section.selector || '.shopify-section');
          if (src) el.innerHTML = src.innerHTML;
        });
      } else if (document.querySelector('cart-items')) {
        window.location.reload();
      }
    },
  };

  // Product page: ensure protection is added alongside the mug when the box is checked.
  document.addEventListener(
    'submit',
    async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (form.dataset.novProtected === '1') return;
      const box = document.querySelector('[data-novele-protection][data-context="product"] input[type=checkbox]');
      if (!box || !box.checked) return;
      const id = PROTECTION.variantId;
      if (!id) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      try {
        const cart = await PROTECTION.cart();
        const has = cart.items.some((i) => i.variant_id === id);
        if (!has) {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          });
        }
      } catch (err) {
        /* fail open: still add the mug */
      }
      form.dataset.novProtected = '1';
      form.requestSubmit();
      setTimeout(() => delete form.dataset.novProtected, 1500);
    },
    true
  );

  // Cart drawer / cart page: toggle protection line.
  document.addEventListener('change', async (e) => {
    const box = e.target;
    if (!box.matches || !box.matches('[data-novele-protection][data-context="cart"] input[type=checkbox]')) return;
    const wrap = box.closest('[data-novele-protection]');
    const id = Number(wrap.dataset.variantId);
    box.disabled = true;
    try {
      const cart = await PROTECTION.cart();
      const line = cart.items.find((i) => i.variant_id === id);
      let state;
      if (box.checked && !line) state = await PROTECTION.add(id);
      else if (!box.checked && line) state = await PROTECTION.setQty(line.key, 0);
      if (state) PROTECTION.render(state);
    } finally {
      box.disabled = false;
    }
  });

  // If the cart only contains protection, remove it.
  async function cleanupOrphanProtection() {
    const id = PROTECTION.variantId;
    if (!id) return;
    try {
      const cart = await PROTECTION.cart();
      if (cart.items.length === 1 && cart.items[0].variant_id === id) {
        const state = await PROTECTION.setQty(cart.items[0].key, 0);
        PROTECTION.render(state);
      }
    } catch (err) {}
  }
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(cleanupOrphanProtection, 400));
  }
  document.addEventListener('DOMContentLoaded', cleanupOrphanProtection);

  /* ---------- Sticky add to cart (mobile) ---------- */
  function initSticky() {
    const bar = document.querySelector('[data-novele-sticky]');
    if (!bar) return;
    const formId = bar.dataset.form;
    const form = document.getElementById(formId);
    const mainBtn = form ? form.querySelector('button[type=submit], button[name=add]') : null;
    if (!form || !mainBtn) return;
    bar.querySelector('[data-novele-sticky-btn]').addEventListener('click', () => {
      mainBtn.click();
    });
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          const show = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    io.observe(mainBtn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
